import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { ChevronRightIcon, Settings02Icon } from '@systemeio/icons';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import { useNotifications } from '../hooks/use-notifications';
import NotificationEmptyList from './notification-empty-list';
import { NotificationItem } from './notification-item';
import NotificationsListSkeleton from './notifications-list-skeleton';
const defaultFilter = {
  onlyUnRead: false
};
interface NotificationsMenuContentProps {
  className?: string;
  limit?: number;
  /** Lets the overlay host close itself once a link or a notification is opened. */
  onNavigate?: () => void;
}
export const NotificationsMenuContent = t0 => {
  const $ = _c(48);
  const {
    className,
    limit: t1,
    onNavigate
  } = t0;
  const limit = t1 === undefined ? 3 : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    pagination
  } = usePagination(true);
  let t2;
  if ($[0] !== limit || $[1] !== pagination) {
    t2 = {
      limit,
      pagination,
      filter: defaultFilter
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    notifications,
    notificationsMeta
  } = useNotifications(t2);
  const {
    isMarkingAllAsRead,
    markAllNotificationsAsRead
  } = useNotificationsActions();
  let t3;
  if ($[3] !== className) {
    t3 = twMerge("flex max-h-full w-115 max-w-full flex-col", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.notifications.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h4 className="min-w-0 truncate text-lg font-semibold">{t4}</h4>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isMarkingAllAsRead || $[10] !== markAllNotificationsAsRead || $[11] !== notificationsMeta?.hasUnread || $[12] !== t) {
    t6 = notificationsMeta?.hasUnread && <Button isLoading={isMarkingAllAsRead} onClick={markAllNotificationsAsRead} size="sm" variant="link">{t("dashboard.notifications.mark_all_read")}</Button>;
    $[9] = isMarkingAllAsRead;
    $[10] = markAllNotificationsAsRead;
    $[11] = notificationsMeta?.hasUnread;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="border-border-200 flex shrink-0 items-center justify-between gap-4 border-b p-4 pb-3">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== notifications || $[18] !== onNavigate) {
    t8 = notifications === undefined ? <NotificationsListSkeleton /> : notifications.items.length > 0 ? notifications.items.map(notification => <NotificationItem key={notification.id} notification={notification} onNavigate={onNavigate} />) : <NotificationEmptyList />;
    $[17] = notifications;
    $[18] = onNavigate;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <div className="flex min-h-0 flex-1 flex-col justify-start gap-1.5 overflow-y-auto px-1.5 py-3">{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LinkWithoutPrefetch href="/profile/notification-settings" />;
    t11 = <Settings02Icon />;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("global.settings");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <span className="truncate">{t12}</span>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== onNavigate || $[29] !== t13) {
    t14 = <Button onClick={onNavigate} variant="ghost-gray" size="sm" render={t10}>{t11}{t13}</Button>;
    $[28] = onNavigate;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LinkWithoutPrefetch href="/notifications" />;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("dashboard.notifications.view_all");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <span className="truncate">{t16}</span>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ChevronRightIcon />;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== onNavigate || $[38] !== t17) {
    t19 = <Button onClick={onNavigate} variant="secondary" size="sm" render={t15}>{t17}{t18}</Button>;
    $[37] = onNavigate;
    $[38] = t17;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t14 || $[41] !== t19) {
    t20 = <div className="border-border-200 flex shrink-0 items-center justify-between gap-4 border-t pt-3 pr-4 pb-4 pl-2">{t14}{t19}</div>;
    $[40] = t14;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20 || $[44] !== t3 || $[45] !== t7 || $[46] !== t9) {
    t21 = <div className={t3}>{t7}{t9}{t20}</div>;
    $[43] = t20;
    $[44] = t3;
    $[45] = t7;
    $[46] = t9;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  return t21;
};